import { render, staticRenderFns } from "./SessionsList.vue?vue&type=template&id=6d25da50&scoped=true"
import script from "./SessionsList.vue?vue&type=script&lang=js"
export * from "./SessionsList.vue?vue&type=script&lang=js"
import style0 from "./SessionsList.vue?vue&type=style&index=0&id=6d25da50&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25da50",
  null
  
)

export default component.exports